/**
 * O visual da campanha, tirado da comunicação oficial (www.cakto.com.br/black-friday,
 * seção do troféu): preto esverdeado, texto quase branco, acento menta e a fonte
 * do sistema em peso leve. Faixa, régua e dialog leem daqui para os três não
 * derivarem um do outro.
 *
 * As imagens são o troféu oficial do site recortado com fundo transparente. O
 * site publica o PNG com fundo preto chapado, que viraria um retângulo escuro
 * em cima do gradiente da faixa.
 */

export const BLACK_CAKTO = {
  font: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  ink: '#F4F6F4',
  mint: '#E4FFEC',
  mintLine: '#C6E8D1',
  muted: '#B4BEB7',
  body: '#BAC7BE',
  faint: '#7F8A83',
  onLight: '#0A100C',
  line: 'rgba(198,232,209,.16)',
  lineStrong: 'rgba(198,232,209,.45)',
  track: 'rgba(198,232,209,.14)',
  bar: 'linear-gradient(90deg, #4E9A66, #E4FFEC)',
  barMuted: 'linear-gradient(90deg, #4A524D, #8E9891)',
  surface: 'linear-gradient(180deg, #060907, #0A100C 62%, #080909)',
  glow: 'radial-gradient(closest-side, rgba(111,191,134,.22), transparent)',
  // Os anéis concêntricos atrás do troféu, como no site.
  rings:
    'repeating-radial-gradient(circle at 50% 80%, rgba(198,232,209,.07) 0 1px, transparent 1px 13px), radial-gradient(circle at 50% 76%, rgba(111,191,134,.2), transparent 55%), linear-gradient(180deg, #060907, #0A100C 62%, #080909)',
  // Apagado: a peça e a régua de quem não bateu a meta.
  mutedFilter: 'grayscale(1) brightness(.85)',
};

const ASSETS = '/assets/awards/black-cakto';

export const BLACK_CAKTO_ASSETS = {
  // 120 px de altura servem a faixa (até ~52 px na tela) com folga para 2x.
  trophySmall: `${ASSETS}/trofeu-black-cakto-100k-120.webp`,
  // 480 px servem o dialog (até ~230 px na tela).
  trophyLarge: `${ASSETS}/trofeu-black-cakto-100k-480.webp`,
  trophyOutline: `${ASSETS}/trofeu-contorno.svg`,
};
